import { render, staticRenderFns } from "./ReleaseDetailModal.vue?vue&type=template&id=48bcdd84&"
import script from "./ReleaseDetailModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDetailModal.vue?vue&type=style&index=0&id=48bcdd84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports